import type { DirectiveBinding, ObjectDirective } from "vue";

function createDirective() {
  const fallbackImageUrls = new WeakMap();

  const handleFallback = (el: HTMLImageElement, binding: DirectiveBinding<string>) => {
    const fallbackSrc = binding.value;
    // 使用一个 img 标签辅助，避免 fallbackSrc 是一个相对路径，而 el.src 是一个绝对路径，导致死循环，不停的给 el.src 赋值。
    const img = document.createElement("img");
    img.src = fallbackSrc;
    fallbackImageUrls.set(el, img.src);

    el.addEventListener("error", () => {
      const fallbackSrc = fallbackImageUrls.get(el)!;
      if (el.src != fallbackSrc) {
        el.src = fallbackSrc;
      }
    });
  };

  return {
    mounted(el, binding) {
      handleFallback(el, binding);
    },
    unmounted(el) {
      fallbackImageUrls.delete(el);
    },
  } satisfies ObjectDirective<HTMLImageElement, string>;
}

export const vFallbackImage = createDirective();
